import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';

import { TitleService } from '../../../../core/services/title.service';
import { KioskSignInFormComponent } from '../../components/kiosk-sign-in-form/kiosk-sign-in-form.component';

@Component({
	selector: 'app-kiosk-sign-in-page',
	imports: [KioskSignInFormComponent, NgOptimizedImage],
	templateUrl: './kiosk-sign-in-page.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class KioskSignInPageComponent implements OnInit {
	private readonly titleService = inject(TitleService);

	/**
	 * Sets the page title for kiosk sign-in.
	 *
	 * @return {void}
	 */
	public ngOnInit(): void {
		this.titleService.setTitle('Kiosk Sign In');
	}
}
